import { render, staticRenderFns } from "./Occurrence.vue?vue&type=template&id=aeaf54ba"
import script from "./Occurrence.vue?vue&type=script&lang=js"
export * from "./Occurrence.vue?vue&type=script&lang=js"
import style0 from "./Occurrence.vue?vue&type=style&index=0&id=aeaf54ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports